import type {
  SchemaBuilderFieldContextValue,
  SchemaBuilderFieldProviderProps,
} from "./schema-builder-field.type";

import { useTranslation } from "react-i18next";

import { useSchemaBuilderFormContext } from "../schema-builder-form";

import {
  filterOptionsByType,
  getOthersFieldsOptions,
} from "./schema-builder-field.helper";

export const useSchemaBuilderFieldContextValue = ({
  schema: currentField,
}: SchemaBuilderFieldProviderProps): SchemaBuilderFieldContextValue => {
  const { t } = useTranslation();

  const { schema: formSchema } = useSchemaBuilderFormContext();

  const formFields = getOthersFieldsOptions({
    currentField,
    formSchema,
    noGroupTxt: t("global:noGroup"),
  });

  const formFieldsNumber = filterOptionsByType(formFields, "number");

  return {
    fieldSchema: currentField,
    formFields,
    formFieldsNumber,
  };
};
